import React, {useEffect, useState} from 'react';
import {Box, Button, Checkbox, CircularProgress, Divider, Paper, TextField} from "@mui/material";
import {useNavigate} from "react-router-dom";
import IsError from "../common/IsError";
import {StyledMainTypography} from "../common/StyledTypography";
import {useTypedSelector} from "../../store";
import {useFormik} from "formik";
import {DoctorSpecialityFormik} from "../../store/rtk-api/doctor/types";
import CustomSearch from "../common/CustomInput";
import CustomDoctorSelect from "./CustomDoctorSelect";
import {
    useCreateSpecialityMutation,
    useEditSpecialityMutation,
    useGetSpecialitiesQuery
} from "../../store/rtk-api/doctor/doctor";
import CustomAlert from "../common/CustomAlert";
import {validationSchema} from "./helper";
import CustomSelect from "../common/CustomSelect";
import {child_ages, for_child_objects} from "../common/helper";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";


const SpecialitiesManage = () => {
    const navigate = useNavigate()
    const {specialities} = useTypedSelector(state => state.speciality)
    const {data: specs, isLoading, isError} = useGetSpecialitiesQuery('')
    const [sum, setSum] = useState(0)
    const [sumChild, setSumChild] = useState(0)
    const [alertOpen, setAlertOpen] = useState(false)
    const {addressId} = useTypedSelector(state=>state.header)
    const [createSpeciality, {
        isLoading: createLoading,
        isError: createError,
        isSuccess: createSuccess
    }] = useCreateSpecialityMutation()

    const [updateSpeciality, {
        isLoading: updateLoading,
        isError: updateError,
        isSuccess: updateSuccess
    }] = useEditSpecialityMutation()

    const formik = useFormik<DoctorSpecialityFormik>({
        enableReinitialize: true,
        validationSchema: validationSchema,
        initialValues: {
            speciality_id: specialities?.speciality.id || null,
            doctor: specialities?.doctor || null,
            child_discount: specialities?.child_discount || 0,
            child_price: specialities?.child_price || "0",
            discount: specialities?.discount || 0,
            for_child: specialities?.for_child !== null ? specialities?.for_child : 2,
            price: specialities?.price || "0",
            child_age_from: specialities?.child_age_from || '0 мес.',
            child_age_to: specialities?.child_age_to || '18 лет',
            is_active:specialities?.is_active !== false,
            address:addressId

        },
        onSubmit: (values) => {
            if (values.doctor && !specialities.id) {
                let forChild = null
                if (values.for_child === 1) {
                    forChild = 1
                } else if (values.for_child === 0) {
                    forChild = 0
                } else if (values.for_child === 2) {
                    forChild = null
                }
                let body = {
                    speciality_id: values.speciality_id,
                    price: parseInt(values.price),
                    discount: values.discount,
                    for_child: forChild,
                    child_price: parseInt(values.child_price),
                    child_discount: values.child_discount,
                    doctor: values.doctor,
                    child_age_from: values.child_age_from,
                    child_age_to: values.child_age_to,
                    is_active: values.is_active,
                    address: values.address
                }
                createSpeciality(body)
            }

            if (values.doctor && specialities.id) {

                let forChild = null
                if (values.for_child === 1) {
                    forChild = 1
                } else if (values.for_child === 0) {
                    forChild = 0
                } else if (values.for_child === 2) {
                    forChild = null
                }

                let body = {
                    id: specialities.id,
                    body: {
                        speciality_id: values.speciality_id,
                        price: parseInt(values.price),
                        discount: values.discount,
                        for_child: forChild,
                        child_price: parseInt(values.child_price),
                        child_discount: values.child_discount,
                        child_age_from: values.child_age_from,
                        child_age_to: values.child_age_to,
                        doctor: values.doctor,
                        is_active: values.is_active,
                        address: values.address
                    }

                }
                updateSpeciality(body)
            }
        }
    })
    const {handleChange, values, handleSubmit,setFieldValue} = formik
    const handleCheckBoxChange = () => {
        setFieldValue('is_active', !values.is_active)
    }

    useEffect(() => {
        if (createSuccess || createError) {
            setAlertOpen(true)
            setTimeout(() => {
                setAlertOpen(false)
            }, 2000)
        }
    }, [createError, createSuccess])
    useEffect(() => {
        if (updateSuccess || updateError) {
            setAlertOpen(true)
            setTimeout(() => {
                setAlertOpen(false)
            }, 2000)
        }
    }, [updateSuccess, updateError])

    const handleSave = () => {
        handleSubmit()
    }
    const goToPrev = () => {
        navigate(-1)
    }
    useEffect(() => {
        if (values.price !== '0') {
            setSum(+values.price - values.discount)
        }

    }, [values.price, values.discount])

    useEffect(() => {
        if (values.child_price !== '0') {
            setSumChild(+values.child_price - values.child_discount)
        }
    }, [values.child_price, values.child_discount])

    return (
        <Box sx={{p: "10px 200px"}}>
            <IsError isError={isError}/>
            <Box sx={{maxWidth: "100%", maxHeight: "100%", p: "30px"}} component={Paper}>
                <div style={{
                    fontSize: "25px",
                    marginBottom: "30px"
                }}>{specialities.id ? `${specialities.speciality.name}` : `Новая специальность`}</div>
                <Divider/>
                <div style={{display:"flex", alignItems:"center", gap:"2px"}}>
                    <Checkbox checked={values.is_active} onChange={handleCheckBoxChange}/> Опубликован
                    <HelpOutlineIcon titleAccess={"Чтобы сохранить данные, нажмите кнопку сохранения ниже."} sx={{color: "primary.main"}}/>
                </div>
                <div style={{
                    display: "flex",
                    gap: "5px",
                    alignItems: "center",
                    margin: "10px 0"
                }}>
                    {/*<CheckBox/> Опубликован*/}
                </div>

                <div style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    marginBottom: "30px"
                }}>
                    <StyledMainTypography>Специальность</StyledMainTypography>
                    <CustomDoctorSelect value={values.speciality_id} handleChange={handleChange} name={"speciality_id"}
                                        width={"600px"} items={specs}/>
                    <StyledMainTypography>Принимает</StyledMainTypography>
                    <CustomDoctorSelect value={values.for_child} handleChange={handleChange} name={"for_child"}
                                        width={"600px"} items={for_child_objects}/>
                    {values.for_child !== 0 && <>
                        <StyledMainTypography>Принимает детей</StyledMainTypography>
                        <div style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "20px",

                        }}>
                            <div>
                                <StyledMainTypography>от </StyledMainTypography>
                                <CustomSelect value={values.child_age_from} handleChange={handleChange}
                                              name={"child_age_from"}
                                              width={"600px"} items={child_ages}/>
                            </div>
                            <div>
                                <StyledMainTypography>до </StyledMainTypography>
                                <CustomSelect value={values.child_age_to} handleChange={handleChange}
                                              name={"child_age_to"}
                                              width={"600px"} items={child_ages}/>
                            </div>
                        </div>
                    </>
                    }
                    {values.for_child !== 1 && <div style={{
                        display: "flex",
                        flexDirection: "row",
                        gap: "20px",
                        alignItems: "center"
                    }}>
                        <div>
                            <StyledMainTypography>Цена взрослого приема</StyledMainTypography>
                            <CustomSearch handleChange={handleChange} values={values} field={"price"} type={"number"}
                                          formik={formik} width={"220px"}/>
                        </div>
                        <div>
                            <StyledMainTypography>Скидка</StyledMainTypography>
                            <CustomSearch handleChange={handleChange} values={values} field={"discount"}
                                          type={"number"} formik={formik} width={"220px"}/>
                        </div>
                        <div>
                            <StyledMainTypography>Итого</StyledMainTypography>
                            <TextField value={sum}/>
                        </div>
                    </div>}
                    {values.for_child !== 0 && <div style={{
                        display: "flex",
                        flexDirection: "row",
                        gap: "20px",
                        alignItems: "center"
                    }}>
                        <div>
                            <StyledMainTypography>Цена детского приема</StyledMainTypography>
                            <CustomSearch handleChange={handleChange} values={values} field={"child_price"}
                                          type={"number"} formik={formik} width={"220px"}/>
                        </div>
                        <div>
                            <StyledMainTypography>Скидка</StyledMainTypography>
                            <CustomSearch handleChange={handleChange} values={values} field={"child_discount"}
                                          type={"number"} formik={formik} width={"220px"}/>
                        </div>
                        <div>
                            <StyledMainTypography>Итого</StyledMainTypography>
                            <TextField value={sumChild}/>
                        </div>
                    </div>}
                </div>

                {createSuccess && alertOpen &&
                    <CustomAlert message={"Специальность успешно создано!"} status={"success"}/>}
                {createError && alertOpen && <CustomAlert message={"Произошла ошибка"} status={"error"}/>}
                {updateSuccess && alertOpen &&
                    <CustomAlert message={"Данные успешно сохранены!"} status={"success"}/>}
                {updateError && alertOpen && <CustomAlert message={"Произошла ошибка"} status={"error"}/>}
                {createLoading && <CircularProgress/>}
                {updateLoading && <CircularProgress/>}

                <Divider/>
                <div style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "10px",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    marginTop: "20px"
                }}>
                    <Button variant={"contained"} onClick={goToPrev}>Назад к списку</Button>
                    <Button variant={"contained"} onClick={handleSave}>Сохранить</Button>
                </div>

            </Box>


        </Box>

    );
};

export default SpecialitiesManage;